const DEFAULT_CONFIG = {
  focus: true,
  target: '_blank'
};

/**
 * Open a url in a new tab
 *
 * @param url The URL to open
 * @param config Object defining how the url should be opened {@see DEFAULT_CONFIG}
 */
export default function (url, config = {}) {
  if (!url) {
    return;
  }

  let mergedConfig = {
    ...DEFAULT_CONFIG,
    ...config
  };

  const win = window.open(url, mergedConfig.target);
  if (win && win.focus && mergedConfig.focus) {
    win.focus();
  }
}
